import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase, AngularFireObject } from 'angularfire2/database';
import { BrowserTransferStateModule } from '@angular/platform-browser/src/browser/transfer_state';
import { MatTableDataSource } from '@angular/material';
import { SoundService } from '../../services/sound.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  botName: string;

  price = 0;
  priceChange = 0;
  resetPrice = 0;
  money = 0;
  heartbeat;

  currentValue = 0;
  cryptoKept = 0;
  cryptoSavedValue = 0;
  totalValue = 0;
  totalCrypto = 0;
  buyOrdersTotal = 0;
  
  buyOrders = [];
  buyOrdersData;
  buyDisplayedColumns = ['price', 'sellPrice', 'resetPrice', 'size', 'profit', 'fib'];
  sellOrders = [];
  sellOrdersData;
  sellDisplayedColumns = ['price', 'sellPrice', 'value', 'size', 'profit', 'fib'];

  logs = [];
  moneyLogs = [];

  pieData = [];
  pieColorScheme = {
    domain: ['#97bdcc', 'lightgrey', '#4c849a', '#AAAAAA']
  };

  lineChartData = [];
  
  constructor(private route: ActivatedRoute, private db: AngularFireDatabase, private soundService: SoundService) { }
  
  ngOnInit() {
    this.route.params.subscribe(params => {
      this.botName = params['botName'];
      this.initDatabase();
    });
  }

  initDatabase() {

    // price, priceChange
    this.db.object('/bots/' + this.botName + '/price')
      .valueChanges().subscribe(price => {
        var newPrice = Number(price);
        if (this.price > 0) {
          this.priceChange = newPrice - this.price;
        }
        this.price = newPrice;

        this.calculateSellOrderValues();
        this.calculateSavedCryptoValue();
      });

    // resetPrice
    this.db.object('/bots/' + this.botName + '/resetPrice')
      .valueChanges().subscribe(price => {
        this.resetPrice = Number(price);
      });

    // buy orders
    this.db.list('/bots/' + this.botName + '/buyOrders').valueChanges().subscribe(data => {
      let sorted = data.sort(function (a: any, b: any) { return (a.fibNum > b.fibNum) ? 1 : -1; });
      this.buyOrdersData = new MatTableDataSource(sorted);
      this.buyOrders = sorted;
      this.calculateBuyOrderAggregates();
    });

    // sell orders
    this.db.list('/bots/' + this.botName + '/sellOrders')
      .valueChanges().subscribe(data => {
        let sorted = data.sort(function (a: any, b: any) { return (Number(a.price) > Number(b.price)) ? 1 : -1; });
        this.sellOrdersData = new MatTableDataSource(sorted);
        this.sellOrders = sorted;
        this.calculateSellOrderValues();
      });

    // logs
    let firstSoundCheck = true;
    this.db.list('/bots/' + this.botName + '/logs',
      ref => ref.limitToLast(20)
    ).valueChanges().subscribe(logs => {
      this.logs = logs.reverse();
      if(firstSoundCheck) {
        firstSoundCheck = false;
        return;
      }
      this.soundService.checkLogForSound(this.logs[0])
    });

    // money logs
    this.db.list('/bots/' + this.botName + '/moneyLog',
      ref => ref.limitToLast(50)
    ).valueChanges().subscribe(moneyLogs =>{
      this.moneyLogs = moneyLogs.reverse();
      this.setLineChartData();
    });

    // heartbeat
    this.db.object('/bots/' + this.botName + '/heartbeat')
      .valueChanges().subscribe(value => {
        this.heartbeat = new Date(Number(value));
      });

    // money
    this.db.object('/bots/' + this.botName + '/money')
      .valueChanges().subscribe(value => {
        this.money = Number(value);
        this.setPieData();
      });


    // cryptoKept, cryptoSavedValue
    this.db.object('/bots/' + this.botName + '/cryptoKept')
      .valueChanges().subscribe(value => {
        this.cryptoKept = Number(value);
        this.calculateSavedCryptoValue();
      });

    // try to determine currency:

    
    // aeSet
    this.db.object('/adaptiveEngine/')
      .valueChanges().subscribe(value => {
        this.adaptiveEngineObj = value;
      });

      this.db.object('/bots/' + this.botName)
      .valueChanges().subscribe(value => {
        this.botObj = value;
      });

  }
  adaptiveEngineObj = {};
  botObj;

  calculateBuyOrderAggregates() {
    // recalculate value of buy orders
    let buyOrdersTotal = 0;

    this.buyOrders.forEach(buyOrder => {
      let orderSize = Number(buyOrder["size"]);
      let orderPrice = Number(buyOrder["price"])

      buyOrdersTotal += (orderSize * orderPrice);
    })

    this.buyOrdersTotal = buyOrdersTotal;
  }

  calculateSavedCryptoValue() {
    // recalc value of crypto kept
    this.cryptoSavedValue = this.price * this.cryptoKept;

    // update pie chart data
    this.setPieData();
  }


  calculateSellOrderValues() {
    // recalc value of sell orders
    let currentValue = 0;
    let totalValue = 0;
    let totalCrypto = 0;

    this.sellOrders.forEach(sellOrder => {
      let orderSize = Number(sellOrder["size"]);
      let orderPrice = Number(sellOrder["price"]);

      totalValue +=  (orderPrice * orderSize);
      currentValue +=  (this.price * orderSize);
      totalCrypto += orderSize;
    });

    this.currentValue = currentValue;
    this.totalValue = totalValue;
    this.totalCrypto = totalCrypto;

    // update pie chart data
    this.setPieData();
  }


  setPieData() {
    this.pieData = [
      {
        name: "money",
        value: this.money
      },
      {
        name: "Current Crypto Value",
        value: this.currentValue
      },
      {
        name: "Crypto Saved Value",
        value: this.cryptoSavedValue
      }
    ];
  }

  setLineChartData() {
    let series = [];
    this.moneyLogs.forEach(moneyLog => {
      series.push({
        name: new Date(Number(moneyLog.time)),
        value: moneyLog.money
      });
    });

    this.lineChartData = [{
      name: 'Money',
      series: series
    }];
  }


}



// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/components/dashboard/dashboard.component.ts